module.exports = __webpack_public_path__ + "static/media/BA.c96fe7bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BA.svg
// module id = 2106
// module chunks = 7